import { render, staticRenderFns } from "./EditSurat.vue?vue&type=template&id=d3791d60&"
import script from "./EditSurat.vue?vue&type=script&lang=js&"
export * from "./EditSurat.vue?vue&type=script&lang=js&"
import style0 from "./EditSurat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports